export const fetcher = (input: RequestInfo, init?: RequestInit | undefined, withAuth = true) =>
  fetch(input, {
    ...init,
    headers: {
      'Content-Type': 'application/json',
      ...(init?.headers || {}),
      Authorization: withAuth ? `Bearer ${localStorage.getItem('token')}` : '',
    },
  })
